"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ShowMore = {
  overflow: 'hidden',
  position: 'relative',
  background: 'inherit'
};
var Shadow = {
  content: '',
  background: 'inherit',
  position: 'absolute',
  bottom: 0,
  right: 0,
  left: 0,
  opacity: 0.93
};
var ButtonDiv = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '15px 0'
};
var Anchor = {
  height: '1px',
  position: 'absolute',
  top: -35
};
var DefaultButton = {
  background: '#26a8da',
  color: '#ffffff',
  padding: '10px 15px',
  borderRadius: '10px',
  width: '40%',
  maxWidth: '250px',
  cursor: 'pointer'
};
var styles = {
  ShowMore: ShowMore,
  Shadow: Shadow,
  ButtonDiv: ButtonDiv,
  Anchor: Anchor,
  DefaultButton: DefaultButton
};
var _default = styles;
exports["default"] = _default;